import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/icon-vinscanner2.svg'
import _imports_1 from '../assets/img/icon-dvi2.svg'
import _imports_2 from '../assets/img/icon-reporting.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "content primary auth"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "VIN Scanner"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "VIN Scanner")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "prose" }, [
      /*#__PURE__*/_createElementVNode("p", null, "No more squinting and typing. Capture a picture of the VIN and save it to the work order - simple.")
    ])
  ])
], -1)
const _hoisted_4 = {
  key: 1,
  class: "content secondary auth"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "DVI"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Digital Vehicle Inspection")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "prose" }, [
      /*#__PURE__*/_createElementVNode("p", null, "True mobile inspections. Add images and video to support all findings, and send to customers' devices.")
    ])
  ])
], -1)
const _hoisted_6 = {
  key: 2,
  class: "content tertiary auth"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "Reporting"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Reporting")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "prose" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Mobile reporting and dashboards for all of your core KPI's and metrics.")
    ])
  ])
], -1)

import { useAuth0 } from "@auth0/auth0-vue";
import { ref, inject, onMounted, watch} from "vue";
import ApiService from "@/service/api.service";
import { openErrorModal } from '@/composables/useErrorLog';
import { useRouter } from 'vue-router';
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  name: 'StoreHome',
  setup(__props) {

const posthog = inject("posthog");
const storeid = ref('');
const role = ref('');
const managedfeatureids = ref('');
const storestatus = ref('');
const allFeatures = ref([]);
const userRoles = ref([]);
const filteredFeatureNames = ref([]);
const featuresFetched = ref(false);
const { isAuthenticated, user, getAccessTokenSilently,isLoading } = useAuth0();
const router = useRouter();
const store = useStore();

onMounted(async () => {
  await listAllFeatures();
});
// watch isLoading and isAuthenticated object to handle auth0 successful login - for initial login
const stop = watch([isLoading, isAuthenticated], async ([loading, auth]) => {
  if (!loading && auth) {
      await listAllFeatures();
    stop();
  }
});
const listAllFeatures = async () => {
  if (isAuthenticated.value && !featuresFetched.value) {
    storeid.value = store.state.storeid;
    const accessToken = await getAccessTokenSilently();
    await ApiService.getStoreDetails(accessToken, storeid.value);    
    role.value = store.state.role;
    storestatus.value = store.state.storestatus;
    managedfeatureids.value = store.state.managedfeatureids;
    allFeatures.value = await getAllFeatures(accessToken);
    userRoles.value = await getAllUserRoles(accessToken);
    featuresFetched.value = true;

    if (storestatus.value == 'Disable') {
      return router.push('/storedisable');
    }

    if (storestatus.value == 'Enable' && managedfeatureids.value !== '') { 
      setFeatures();
    }
  }
  return;
}

/**
 * Filtering of features based on store features and user role
 */
const setFeatures = () => {
  const actualRole = userRoles.value.filter((item) => item.userrole === role.value)[0];

  // if the Store detail has no managedfeatureids then select all non-manageable feature in features table
  if (managedfeatureids.value === null) {
    // get all non-manageable features, it is accessible by default
    const filteredFeatures = allFeatures.value.filter((feature) => feature.manageable === false);
    // get only the feature names for simplicity
    filteredFeatureNames.value = filteredFeatures.map((item) => item.featurename);
    return;
  }
  // managedfeatureids exists in store details
  // if the Store detail has managedfeatureids but the role has no availablefeatureids, then use the managedfeatureids as features
  if (actualRole.availablefeatureids === null) {
    const storemanagedfeatureids = managedfeatureids.value.split(',').map(Number);
    const filteredFeatures = allFeatures.value.filter((feature) => storemanagedfeatureids.includes(feature.featureid) || feature.manageable === false);
    // get only the feature names for simplicity
    filteredFeatureNames.value = filteredFeatures.map((item) => item.featurename);
    return;
  }

  // if the Store detail has managedfeatureids and the role has availablefeatureids, return the matching ids in user role details and store details
  const roleavailablefeatureids = actualRole.availablefeatureids.split(',').map(Number);
  const storemanagedfeatureids = managedfeatureids.value.split(',').map(Number);

  // select only the matching ids between user role and store details
  const filteredfeatureids = roleavailablefeatureids.filter((item) => storemanagedfeatureids.includes(item));
  // select the feature items in feature table based on filteredfeatureids or non-manageable features, it is accessible by default
  const filteredFeatures = allFeatures.value.filter((feature) => filteredfeatureids.includes(feature.featureid) || feature.manageable === false);
  // get only the feature names for simplicity
  filteredFeatureNames.value = filteredFeatures.map((item) => item.featurename);
}

/**
 * API request for getting all feaures
 * @param accessToken 
 */
const getAllFeatures = async (accessToken: string) => {
	try {
		const response: Response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/features", {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		const data = await response.json();
    if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		return data.message;
	} catch (e) {
    openErrorModal(e.message);
	}
}

/**
 * API request for getting all user roles
 * @param accessToken 
 */
const getAllUserRoles = async (accessToken: string) => {
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/userroles";
	try {
		const response: Response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		const data = await response.json();
    if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		return data.message;
	} catch (e) {
		openErrorModal(e.message);
	}
}

const captureFeature = (event: MouseEvent, tabName: string) => {
  event.preventDefault();
  const email = user.value.email;
  posthog.capture(`${tabName}_tab_clicked`, { email: email });
}

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isAuthenticated) && filteredFeatureNames.value.length !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (filteredFeatureNames.value.includes('VINScanner'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: { name: 'workorders', params: { url: '/workorders' }},
                onClick: _cache[0] || (_cache[0] = (event) => captureFeature(event, 'vinscanner'))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Card, null, {
                    content: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (filteredFeatureNames.value.includes('DVI'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: 'dviworkorders', params: { url: '/dviworkorders' }},
                onClick: _cache[1] || (_cache[1] = (event) => captureFeature(event, 'dvi'))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Card, null, {
                    content: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (filteredFeatureNames.value.includes('Reporting'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: { name: 'reporting', params: { url: '/reporting' }},
                onClick: _cache[2] || (_cache[2] = (event) => captureFeature(event, 'reporting'))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Card, null, {
                    content: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})